export const environment = {
  production: true,
  baseUrl: 'https://pcc-backend-dev-3672zeg3ra-ts.a.run.app',
  appTitle: 'Partner Control Centre - DEVELOPMENT',
  shortAppTitle: 'Partners',
  appCompanyName: 'Winning Group',
  mobileMaxWidth: 428
};
